/**
 * Hooks لقراءة بطاقات overlay على بلوكات المجموعات.
 * - useCollectionOverlays(handles): جلب bulk للسوق الحاليّ، runtime عامّ.
 * - useAllCollectionOverlays(): للأدمن — كلّ البطاقات.
 */
import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import {
  fetchPublicCollectionOverlays,
  type ActiveOverlay,
} from "@/lib/publicCollectionOverlays";
import {
  listCollectionOverlays,
} from "@/lib/admin/collectionOverlays.functions";
import { useLocale } from "@/contexts/LocaleContext";
import { useAdminGate } from "@/hooks/useAdminGate";

export type { ActiveOverlay } from "@/lib/publicCollectionOverlays";

export function useCollectionOverlays(handles: string[]) {
  const { effectiveMarket } = useLocale();
  const keyHandles = [...handles].sort().join(",");
  return useQuery({
    queryKey: ["collection-overlays", effectiveMarket, keyHandles],
    queryFn: () => fetchPublicCollectionOverlays(handles, effectiveMarket),
    enabled: handles.length > 0,
    staleTime: 60_000,
  });
}

export function useAllCollectionOverlays(enabled = true) {
  const { ready } = useAdminGate(enabled);
  const fetchFn = useServerFn(listCollectionOverlays);
  return useQuery({
    queryKey: ["collection-overlays", "admin"],
    queryFn: () => fetchFn(),
    enabled: ready,
    staleTime: 30_000,
  });
}
